var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.6 12.4H4.45L10.7 6.15L9.85 5.3L3.6 11.55V12.4ZM2.4 13.6V11.05L10.7 2.75C10.8222 2.62778 10.9547 2.53889 11.0973 2.48333C11.2399 2.42778 11.3899 2.4 11.5473 2.4C11.7047 2.4 11.8556 2.42778 12 2.48333C12.1444 2.53889 12.2778 2.62778 12.4 2.75L13.25 3.6C13.3722 3.72222 13.4611 3.85556 13.5167 4C13.5722 4.14444 13.6 4.29189 13.6 4.44233C13.6 4.60289 13.5721 4.75589 13.5163 4.90133C13.4606 5.04678 13.3718 5.17967 13.25 5.3L4.95 13.6H2.4ZM10.2675 5.7325L9.85 5.3L10.7 6.15L10.2675 5.7325Z",
    fill: "#222A38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.c13b7cf8ac5f1b71f6a9eff73a476669.svg";
export { ForwardRef as ReactComponent };